import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";
import { useI18n } from "@/i18n/I18nProvider";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ShieldCheck, ArrowLeft, MailCheck } from "lucide-react";

export default function ForgotPasswordPage() {
  const { t, lang } = useI18n();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-6">
      <div className="w-full max-w-md">
        <div className="mb-10">
          <img
            src="https://customer-assets-39nsmqrw.emergentagent.net/job_attestguard/artifacts/3wuvsw34_FORMATO-WEB-NERO.jpg"
            alt="Sicurgarda"
            className="h-10 w-auto"
          />
        </div>

        {sent ? (
          <div className="bg-card border border-border rounded-lg p-8">
            <div className="w-12 h-12 rounded-md bg-[hsl(var(--success-bg))] text-[hsl(var(--success))] grid place-items-center mb-4">
              <MailCheck className="w-6 h-6" />
            </div>
            <h2 className="text-2xl font-bold tracking-tight">{t("check_your_inbox")}</h2>
            <p className="text-muted-foreground text-sm mt-3">{t("reset_link_sent")}</p>
            <Link to="/login" className="inline-flex items-center gap-1.5 mt-6 text-xs uppercase tracking-widest text-primary btn-lift">
              <ArrowLeft className="w-3.5 h-3.5" /> {t("back_to_login")}
            </Link>
          </div>
        ) : (
          <>
            <h2 className="text-3xl font-bold tracking-tight">{t("forgot_password_title")}</h2>
            <p className="text-muted-foreground text-sm mt-2">{t("forgot_password_sub")}</p>

            <form onSubmit={submit} className="mt-8 space-y-5">
              <div>
                <Label className="text-xs uppercase tracking-widest text-muted-foreground">{t("email")}</Label>
                <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email-input" className="mt-2 h-12" />
              </div>
              {error && <div className="text-sm text-[hsl(0,70%,40%)] bg-[hsl(0,90%,94%)] border rounded-md px-3 py-2">{error}</div>}
              <Button type="submit" disabled={loading} data-testid="forgot-submit-button" className="w-full h-12 rounded-full btn-lift">
                {loading ? "…" : (lang === "it" ? "Invia link di reset" : "Send reset link")}
              </Button>
            </form>

            <Link to="/login" className="inline-flex items-center gap-1.5 mt-8 text-xs uppercase tracking-widest text-muted-foreground hover:text-foreground btn-lift">
              <ArrowLeft className="w-3.5 h-3.5" /> {t("back_to_login")}
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
